export default __webpack_public_path__ + "src/images/packages/lush-private-game-lodge/af37685086ec56ea0886a8478f921734-3.jpg";